import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/interest-coverage-calculator',
  component: () => import('../../routes/InterestCoverageCalculator.svelte'),
  card: {
    id: 'interest-coverage-calculator',
    title: 'Interest Coverage Ratio Calculator',
    description:
      'Calculate the Interest Coverage Ratio (Times Interest Earned) to assess how easily a company can pay interest on its outstanding debt.',
    icon: 'shield',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/interest-coverage-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Interest Coverage Ratio Calculator – Times Interest Earned (TIE)',
    description:
      'Free Interest Coverage Ratio (Times Interest Earned) calculator. Assess a company\'s ability to pay debt obligations. Enter EBIT and interest expense for instant results.',
  },
};

export default meta;